const ReactInstructionHtml = () => {
  return (
    <div className="instructions">
      <p>1. Copy the provided code and paste it into the JSX file where you want it to be displayed.</p>
    </div>
  )
}
export default ReactInstructionHtml
